import React from 'react';
import { CtaButton } from '@web/molecules';
import { CTAGroup } from '../CTAGroup';

const withAlignment = (cta, alignmentOverride) => {
  if (!alignmentOverride) {
    return cta;
  }

  return { ...cta, alignment: alignmentOverride };
};

const ctaWidthProps = cta => ({
  minWidth: cta.minWidth,
  fullWidthMobile: cta.fullWidthMobile,
  fullWidthDesktop: cta.fullWidthDesktop,
});

export const renderStoryCardsCta = (cta, { alignmentOverride } = {}) => {
  if (!cta) {
    return null;
  }

  if (cta.component === 'cta_group') {
    return (
      <CTAGroup
        {...cta}
        ctas={(cta.ctas || []).map(button =>
          withAlignment(button, alignmentOverride),
        )}
      />
    );
  }

  if (cta.href) {
    const resolvedCta = withAlignment(cta, alignmentOverride);

    return (
      <CtaButton
        href={resolvedCta.href}
        variant={resolvedCta.variant || 'primary'}
        headerText={resolvedCta.headerText}
        alignment={resolvedCta.alignment}
        triggerModal={resolvedCta.triggerModal}
        modal={resolvedCta.modal}
        openNewTab={resolvedCta.openNewTab}
        icon={resolvedCta.icon}
        iconAlignment={resolvedCta.iconAlignment}
        {...ctaWidthProps(resolvedCta)}
      >
        {resolvedCta.children}
      </CtaButton>
    );
  }

  if (cta.target) {
    const resolvedCta = withAlignment(cta, alignmentOverride);

    return (
      <CtaButton
        href={resolvedCta.target}
        variant={resolvedCta.variant || 'primary'}
        headerText={resolvedCta.headerText}
        alignment={resolvedCta.alignment}
        triggerModal={resolvedCta.triggerModal}
        modal={resolvedCta.modal}
        openNewTab={resolvedCta.openNewTab}
        icon={resolvedCta.icon}
        iconAlignment={resolvedCta.iconAlignment}
        {...ctaWidthProps(resolvedCta)}
      >
        {resolvedCta.text}
      </CtaButton>
    );
  }

  return null;
};
